import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import CodeIcon from "@material-ui/icons/Code";
import StorageIcon from "@material-ui/icons/Storage";
import DevicesIcon from "@material-ui/icons/Devices";
import "./about.css";

const useStyles = makeStyles({
  avatar: {
    width: 150,
    height: 150,
  },

  button: {
    borderRadius: 30,
    textTransform: "none",
    fontWeight: 600,
    padding: "11px 25px",
  },
});

export default function About() {
  const classes = useStyles();

  return (
    <section id="about" className="about-section">

      {/* Section heading */}
      <div className="section-heading">
        <span>Get To Know Me</span>
        <h1>About Me</h1>
      </div>

      <div className="about-container">

        {/* Left side */}
        <div className="about-intro">

          <div className="about-text">

            <p>
              I build modern, scalable, and user-friendly web applications
              with a strong focus on clean code, performance, and great
              user experiences.
            </p>

            <p>
              My experience spans both frontend and backend development,
              working with technologies such as React, Vue.js, TypeScript,
              JavaScript, Node.js, REST APIs, and database-driven
              applications.
            </p>

            <p>
              I've worked on business and enterprise applications including
              payment management systems, work order platforms, price book
              editors, and warehouse solutions.
            </p>

            <Button
              className={classes.button}
              variant="contained"
              color="secondary"
              href="https://drive.google.com/uc?export=download&id=16KQhH12QaUxxlZfshoKVGM067l-7a6Ol"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </Button>

          </div>
        </div>


        {/* Right side - Skills */}
        <div className="skills-card">

          <div className="skills-header">
            <h2>My Expertise</h2>
            <p>
              Technologies and areas I work with
            </p>
          </div>


          <div className="skill">

            <div className="skill-title">
              <span>
                <CodeIcon />
                Frontend Development
              </span>

              <strong>90%</strong>
            </div>

            <div className="progress">
              <div
                className="progress-fill blue"
                style={{ width: "90%" }}
              ></div>
            </div>

          </div>


          <div className="skill">

            <div className="skill-title">
              <span>
                <StorageIcon />
                Backend Development
              </span>

              <strong>80%</strong>
            </div>

            <div className="progress">
              <div
                className="progress-fill pink"
                style={{ width: "80%" }}
              ></div>
            </div>

          </div>


          <div className="skill">

            <div className="skill-title">
              <span>
                <DevicesIcon />
                UI/UX Development
              </span>

              <strong>85%</strong>
            </div>

            <div className="progress">
              <div
                className="progress-fill yellow"
                style={{ width: "85%" }}
              ></div>
            </div>

          </div>


          <div className="skill">

            <div className="skill-title">
              <span>
                <StorageIcon />
                Full-Stack Development
              </span>

              <strong>85%</strong>
            </div>

            <div className="progress">
              <div
                className="progress-fill green"
                style={{ width: "85%" }}
              ></div>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
}